//
// Mobile detection and updating
//=========================================
var isMobile;

/**
 * add event listerer
 */
$(window).resize(function () {
	checkScreenSize();
});

/**
 * Initiate
 */
checkScreenSize();

// adding appointment block toggle to mobile
$(document).on('click', '.appointment-block--mobile .appointment-block__header', function (ev) {
	$(ev.target).toggleClass('appointment-block__header--opened')
	$('.appointment-block__collapse').collapse('toggle');
})
$(document).on('click', '.nav-item--phone .nav-link, .phone-link', function (ev) {
	pushDatalayerEvent('call_click', 'call_click_cross_site');
});
$(document).on('click', '.nav-item--whatsapp .nav-link, .whatsapp-link', function (ev) {
	pushDatalayerEvent('whatsapp_click', 'whatsapp_click_cross_site');
});

function pushDatalayerEvent(event, name) {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		'event': event,
		'object_type': 'medor.co.il',
		'object_name': name,
		'page_url': window.location.href
	});
}

// adding ajax to forms
$(document).on('submit', 'form', function (ev) {
	ev.preventDefault();

	const $form = $(ev.target);

	disableForm($form)

	const url = $form.attr('action');
	const data = $form.serialize();

	$.ajax({
		type: "POST",
		url: url,
		data: data,
		success: function (data) {
			// if successful we resubmit the form without ajax.
			$(document).off('submit', 'form');
			$form.submit();
			// window.location = "forms/thanks";
		},
		error: function (xhr, ajaxOptions, thrownError) {
			// clearing all errors
			$form.find('.is-invalid').removeClass('is-invalid')
			$form.find('.invalid-feedback').remove();

			// filling errors
			const errors = JSON.parse(xhr.responseText);
			$.each(errors, function (key, error) {
				$form.find('[name="' + key + '"]')
					.addClass('is-invalid')
					.after('<small class="invalid-feedback">' + error[0] + '</small>');
			});

			$form.find('[name="' + Object.keys(errors)[0] + '"]').focus();

			enableForm($form);
		}
	});
});

function disableForm($form) {
	$form.find('button[type="submit"]').prop( "disabled", true );
}
function enableForm($form) {
	$form.find('button[type="submit"]').prop( "disabled", false );
}

/**
 * Check the screen size and act apon it.
 */
function checkScreenSize() {
	if ($('body').width() >= 992) {
		setDesktop();
	} else {
		setMobile();
	}
}

/**
 * Activate the mobile mode
 */
function setMobile() {
	if (isMobile == true) {
		return;
	}
	isMobile = true;

	removeDesktopListener();

	// reposition menu for mobile
	$('#menu-collapse').append($('.navbar-nav'));
	$('.lvl-1').each(function (index, lvl1) {
		 const $lvl1 = $(lvl1);
		 $lvl1
			 .append($('#banner-link-' + $lvl1.data('itemId')))
			 .append($('#ul-' + $lvl1.data('itemId')))
	})

	// update appointment block
	var appointmentBlock = $('.appointment-block');
	appointmentBlock.find('.appointment-block__collapse').addClass('collapse');
	$('.main-header').append(
		appointmentBlock.addClass('appointment-block--mobile')
	)
}

/**
 * Activate the desktop mode
 */
function setDesktop() {
	if (isMobile == false) {
		return;
	}
	isMobile = false;

	// update appointment block
	$('#appointment-block-wrapper').append($('.appointment-block').removeClass('appointment-block--mobile'))

	// reposition menu for desktop
	// $('.collapse').collapse('hide');
	$('.navbar').append($('.navbar-nav'));
	$('.lvl-1').each(function (index, lvl1) {
		const collapse = $(lvl1).children('.collapse').collapse('hide');
		const bannerLink = $(lvl1).children('.banner-link');
		const navClose = $(lvl1).children('.nav-close');
        $('<div class="container"></div>')
            .append(collapse.append(bannerLink))
            .append(collapse.append(navClose))
            .appendTo($('#desktop-collapse'));
	})

	addDesktopListener();
}

function addDesktopListener() {
	$('.main-header').on('show.bs.collapse', function (ev) {
		const eventId = ev.target.id;
		$('#'+eventId).addClass('z-top');
		$('.main-header .collapse-lvl-1:not("#'+eventId+'")').removeClass('z-top').collapse('hide');
	})
	$('.main-header .nav-close').on('click', function (ev) {
		$('.main-header .collapse-lvl-1').collapse('hide');
	});
}

function removeDesktopListener() {
	$('.main-header	').off('show.bs.collapse');
	$('.main-header .nav-close').off('click');
}


/**
 * Cookies
 */

const cookieConsentLink = document.querySelector('#cookies-consent-link');
if (cookieConsentLink) {
	cookieConsentLink.addEventListener('click', consentToCookies)
}

function consentToCookies(ev) {
	ev.preventDefault();
	fetch(ev.target.getAttribute('href')).then((response) => {
		ev.target.removeEventListener('click', this.consentToCookies);
		const cookiesConsent = document.querySelector('.cookies-consent');
		if (cookiesConsent) {
			cookiesConsent.remove();
		}

	})

}




// WEBPACK FOOTER //
// ./resources/assets/js/site.js